// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { LinkFragmentDoc } from '../../../../../graphql/api/cms/link.fragment.generated';
import { SubMenuFragmentDoc } from './SubMenu.fragment.generated';
export const HeaderMenuFragmentDoc = gql`
    fragment headerMenu on MenuItem {
  __typename
  title
  hideOnMobile
  hideOnDesktop
  link {
    ...link
  }
  subMenu {
    ...subMenu
  }
}
    ${LinkFragmentDoc}
${SubMenuFragmentDoc}`;